exports.components = {
  "component---src-pages-apps-js": () => import("./../../../src/pages/Apps.js" /* webpackChunkName: "component---src-pages-apps-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("./../../../src/pages/Projects.js" /* webpackChunkName: "component---src-pages-projects-js" */),
  "component---src-pages-resume-js": () => import("./../../../src/pages/Resume.js" /* webpackChunkName: "component---src-pages-resume-js" */)
}

